<template>
	<section>
		<!--工具条-->		
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			
		</el-col>

		<!--列表-->
		<el-table :data="datalist" border stripe highlight-current-row v-loading="listLoading" style="width:95%;" height="500">
			<el-table-column prop="spname" label="上游" min-width="60"></el-table-column>
			<el-table-column prop="cpname" label="渠道" min-width="60"></el-table-column>
			<el-table-column prop="site" label="站点" min-width="100">
				<template slot-scope="scope"><span v-html="formateStatus(scope.row)"></span></template>
			</el-table-column>
			<el-table-column prop="revenue" label="昨日收益" min-width="100"></el-table-column>
			<el-table-column prop="type1" label="day1" min-width="60"></el-table-column>
			<el-table-column prop="type2" label="day2" min-width="60"></el-table-column>
			<el-table-column prop="type3" label="day3" min-width="60"></el-table-column>
			<el-table-column prop="type4" label="day4" min-width="60"></el-table-column>
			<el-table-column prop="type5" label="day5" min-width="60"></el-table-column>
			<el-table-column prop="type6" label="day6" min-width="60"></el-table-column>
		</el-table>
	</section>
</template>

<script>
	import util from '../../common/js/util'
	import { getListPage, delData, saveData } from '../../api/api';

	export default {
		data() {
			return {
				filters: {
					entimes:'',
					entimee:'',
					codes:'',
					scode:'',
					cpcode:'',
					showtime:false,
					showtimeTable:false,
					showsite:false,
					showsiteTable:false,
					noShowColTable:false,
					showspinfo:false,
					showspinfoTable:false,
					showcpinfo:false,
					showcpinfoTable:false,
				},
				splist:[],
				cplist:[],
				datalist: [],
				tgsList:[],
				service_options:[],
				total: 0,
				pagesize:20,
				page: 1,
				listLoading: false,
			}
		},
		methods: {
			formateStatus:function(row){
				return (`<span style="color:${row.thecolor}">${row.site}</span>`)
			},
			getSpList(){
				let para = {
					actionurl:'default/getListAll',
					sqlid:'html_spinfo.query',
				};
				getListPage(para).then((res) => {
					if(res.data.status==-200){
						this.$message({
							message: res.data.message,
							type: res.data.type
						});
					}else{
						this.splist = res.data.datas;
					}
				});
				
			},
			getCpList(){
				let para = {
					actionurl:'default/getListAll',
					sqlid:'html_cpinfo.query',
				};
				getListPage(para).then((res) => {
					if(res.data.status==-200){
						this.$message({
							message: res.data.message,
							type: res.data.type
						});
					}else{
						this.cplist = res.data.datas;
					}
				});
				
			},
			clarnQuery:function(){
				this.filters.scode = '';
				this.filters.cpcode = '';
			},
			getLists:function(){
				let para = {
					entimes:this.filters.entimes,
					entimee:this.filters.entimee,
					codes:this.filters.codes,
					scode:this.filters.scode,
					cpcode:this.filters.cpcode,
					actionurl:'datas/checkData'
				};
				
				if(this.filters.showtime){
					para.showtime = 1 ;
				}
				if(this.filters.showsite){
					para.showsite = 1 ;
				}
				if(this.filters.showspinfo){
					para.showspinfo = 1 ;
				}
				if(this.filters.showcpinfo){
					para.showcpinfo = 1 ;
				}
				
				this.listLoading = true;
				//NProgress.start();
				getListPage(para).then((res) => {
					if(!util.checkLogOut(this,res.data)){
						this.filters.showtimeTable = this.filters.showtime ;
						this.filters.showsiteTable = this.filters.showsite;
						this.filters.showspinfoTable = this.filters.showspinfo;
						this.filters.showcpinfoTable = this.filters.showcpinfo;
						
						console.log(">>>"+this.filters.showspinfo);
						this.total = res.data.total;
						this.datalist = res.data.datas;
					}
					
					this.listLoading = false;
					//NProgress.done();
				});
			}
		},
		mounted() {
			this.getSpList();
			this.getCpList();
			this.filters.entimes = util.formatDate.getdatestr(-1, 'yyyy-MM-dd');
			this.filters.entimee = util.formatDate.getdatestr(-1, 'yyyy-MM-dd');
			this.getLists();
		}
	}

</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// checkData.vue?5d78a05a